export default __webpack_public_path__ + "static/media/IMG_6496.032091aa.jpeg";